export const fields = [
  { id: 0, name: "全分野" },
  { id: 1, name: "建築" },
  { id: 2, name: "水道" },
  { id: 3, name: "プラント" },
];

// export const fields = [
//   { id: "0", name: "全分野" },
//   { id: "1", name: "建築" },
//   { id: "2", name: "水道" },
//   { id: "3", name: "プラント" },
// ];
